export default __webpack_public_path__ + "static/media/newParceiro.cb40a7e4.png";